export const UPLOAD_OPTIONS = {
  FOLDER_SHARE_LINK: 'folder-share-link',
  IMAGELESS: 'imageless-video-report',
  IMAGE_UPLOAD: 'image-upload',
  ONLINE_PORTAL_ACCESS: 'online-portal-access',
  PO_BOX_MAIL: 'po-box-mail',
  UPLOAD_SELF: 'upload-self',
  USE_EXISTING_STUDY: 'use-existing-study',
};

export const ROLES = {
  ADMIN: {
    label: 'ADMIN',
    label2: 'Admin',
    role: 'admin',
    value: 'ADMIN',
  },
  CREATOR: {
    label: 'CREATOR',
    label2: 'Creator',
    role: 'creator',
    value: 'CREATOR',
  },
  LEAD_TECH: {
    label: 'LEAD TECH',
    label2: 'Lead Tech',
    role: 'lead-tech',
    value: 'LEAD-TECH',
  },
  PATIENT: {
    label: 'PATIENT',
    label2: 'Patient',
    role: 'patient',
    value: 'PATIENT',
  },
  RADIOLOGIST: {
    label: 'RADIOLOGIST',
    label2: 'Radiologist',
    role: 'radiologist',
    value: 'RADIOLOGIST',
  },
  SUPER_ADMIN: {
    label: 'SUPER ADMIN',
    label2: 'Super Admin',
    role: 'super-admin',
    value: 'SUPER-ADMIN',
  },
  TECHNOLOGIST: {
    label: 'TECHNOLOGIST',
    label2: 'Technologist',
    role: 'technologist',
    value: 'TECHNOLOGIST',
  },
  TRAINEE: {
    label: 'TRAINEE',
    label2: 'Trainee',
    role: 'trainee',
    value: 'TRAINEE',
  },
};

export const ROLES_LABELS = {
  admin: 'Admin',
  creator: 'Creator',
  'lead-tech': 'Lead Tech',
  patient: 'Patient',
  radiologist: 'Radiologist',
  'super-admin': 'Super Admin',
  technologist: 'Technologist',
  trainee: 'Trainee',
};

export default {
  ROLES,
  ROLES_LABELS,
  UPLOAD_OPTIONS,
};
